import {
	GET_FULLY_PAID_SECURITIES_LENDING_CONFIRMATIONS_SUCCESS,
	GET_FULLY_PAID_SECURITIES_LENDING_CONFIRMATIONS_ERRORED,
} from '../../actions/api/clearing';
import {
	handleSuccessCase,
	handleErroredCase,
} from './utils/fullyPaidSecuritiesLendingConfirmationsHelpers';

/**
 * Reducer for fully paid securities lending confirmations
 * Focuses on routing actions to appropriate handlers, delegating state transformation to pure functions
 * @param {Object} state - Current reducer state
 * @param {Object} action - The Redux action
 * @returns {Object} - New state
 */
const fullyPaidSecuritiesLendingConfirmationsReducer = (state = {}, action) => {
	switch (action.type) {
		case GET_FULLY_PAID_SECURITIES_LENDING_CONFIRMATIONS_SUCCESS:
			return handleSuccessCase(state, action);
		case GET_FULLY_PAID_SECURITIES_LENDING_CONFIRMATIONS_ERRORED:
			return handleErroredCase(state, action);
		default:
			return state;
	}
};

export default fullyPaidSecuritiesLendingConfirmationsReducer;
